<template>
  <div class="container-fluid">
    <div v-if="modal_invoice_preview == false" class="row noprint">
      <div class="order-left-side">
        <div class="mobile-button">
          <ul class="nav nav-pills nav-fill">
            <li
              class="nav-item"
              style="
                text-align: left;
                background: #f5f5f5;
                padding-top: 20px;
                padding-bottom: 10px;
                padding-left: 10px;
              "
            >
              <h4>
                <v-icon style="padding-right: 20px"> mdi-cart-outline </v-icon>
                <span class="badge total_items">{{ total_items }}</span>
                Total: {{ total }}
              </h4>
            </li>
            <li class="nav-item cart" @click="mobile_cart = !mobile_cart">
              CART
              <span class="btn-cart">
                <v-icon v-if="!mobile_cart">mdi-chevron-down</v-icon>
                <v-icon v-if="mobile_cart">mdi-chevron-up</v-icon>
              </span>
            </li>
          </ul>
        </div>

        <div class="d-flex wrap-cateogry">
          <button
            class="btn btn-default m-2"
            style="height: 50px"
            @click="$router.push({ name: 'home' })"
          >
            {{ $t("Back") }}
          </button>
          <button
            :v-tooltip="$t('Category')"
            class="btn btn-default m-2"
            style="height: 50px"
            @click="modal_category = true"
          >
            <icon icon="grid" />
            <span v-if="selected_category.id" class="ml-1"
              >| {{ selected_category.title }}</span
            >
            <span v-else class="ml-1"
              >| {{ $t("All") + " " + $t("Category") }}</span
            >
          </button>
          <form class="m-2 form-search-products" @submit.prevent="findItem">
            <div class="input-group mb-3">
              <input
                v-model="search_item"
                type="text"
                class="form-control"
                placeholder="Find menu code, name..."
              />
              <div class="input-group-append pointer" @click="findItem">
                <span id="basic-addon2" class="input-group-text">
                  <icon icon="search" />
                </span>
              </div>
            </div>
          </form>
        </div>

        <!-- item -->
        <loading v-if="loading" class="order-loading itemListEmpty" />
        <nodata
          v-if="!loading & (items.length < 1)"
          class="text-center itemListEmpty"
        />

        <VuePerfectScrollbar class="scroll-item">
          <div v-if="!loading" class="wrap-item">
            <item
              v-for="item in items"
              :key="item.id"
              class="pointer"
              :item="item"
              @click="openModalMenu(item)"
            />
            <div
              v-if="meta_item.current_page !== meta_item.last_page"
              class="item pointer"
              @click.prevent="getMoreItems(1)"
            >
              <div class="card item-card shadow-sm" style="background: #e0e0e0">
                <div class="text-center next-item">
                  <img src="@/assets/images/more.png" alt />
                </div>
                <div class="body product_item">
                  <div class="product_details p-2">
                    {{ $t("more") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>

        <!-- end item -->

        <div class="btn-actions pl-5 pt-1">
          <h6 class="mb-0">
            <img src="@/assets/images/store.svg" width="25" alt />
            {{ restaurant.name }}
          </h6>
        </div>
      </div>
      <div
        v-if="modal_invoice_preview == false"
        class="order-right-side"
        :class="{ 'show-mobile-cart': mobile_cart }"
      >
        <div class="right-top mb-4">
          <div
            v-tooltip="'Select Customer'"
            class="float-left pointer"
            @click="showCustomerDialog()"
          >
            <icon icon="user-plus" class="icon" />
            <span class="ml-2">{{ customer.name }}</span>
          </div>
          <div class="float-right pointer">
            <span
              v-if="order_type === 'walk_in' || order_type === 'hotel_guest'"
              @click="showModalTable()"
            >
              <v-icon v-if="order_type === 'walk_in'" v-tooltip="'Select Table'"
                >mdi-table-furniture</v-icon
              >
              <v-icon
                v-if="order_type === 'hotel_guest'"
                v-tooltip="'Select Hotel'"
                >mdi-room-service</v-icon
              >
              <span class="ml-2">{{ table_selected.name }}</span>
            </span>
            <v-icon
              v-if="!order_modify.id"
              v-tooltip="'Clear Order'"
              class="ml-4"
              @click="clearOrder(true)"
            >
              mdi-delete
            </v-icon>
          </div>
        </div>
        <!-- end customer and loction -->
        <!-- table order -->
        <div class="table-responsive">
          <table class="table table-hover tableheader">
            <thead ref="invoiceHeader">
              <tr>
                <th>{{ $t("Description") }}</th>
                <th>{{ $t("qty") }}</th>
                <th class="text-rightss" colspan="2">
                  {{ $t("amount") }}
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <VuePerfectScrollbar
          class="scrol-right-side-order"
          :class="{
            'scrol-right-side-order-exclusive':
              restaurant.tax_type !== 'EXCLUSIVE',
          }"
          style="background: whitesmoke"
        >
          <div v-if="!(order_items.length > 0)" class="orderEmpty">
            <img src="@/assets/images/cart.svg" width="50" alt="" />
            <h4>
              {{ $t("Order is empty") }}
            </h4>
            <p>Add items from catalog</p>
          </div>
          <div class="table-responsive">
            <table class="table table-striped table-hover theme-color c_table">
              <tbody v-if="order_items.length > 0">
                <tr v-for="(item, item_index) in order_items" :key="item_index">
                  <td class="item_description item-title h50">
                    <p>{{ item.item_org.title }}</p>
                    <p v-if="item.discount > 0" class="item-description">
                      Disc:
                      <span v-if="item.item_discount_percent">
                        ({{ item.item_discount_percent }}%)
                      </span>
                    </p>
                    <template v-for="(op, op_index) in item.options">
                      <p :key="op_index" class="item-description">
                        {{ op.title }} :
                      </p>

                      <template v-for="(opl, opl_index) in op.optionvalues">
                        <p
                          :key="opl_index + '__' + op_index"
                          class="item-description"
                        >
                          --- {{ opl.title }}
                        </p>
                      </template>
                    </template>
                    <p v-if="item.note != ''">{{ $t('Note')}}: {{ item.note }}</p>
                  </td>
                  <td class="item_qty_invoice">
                    {{ item.quantity }}
                  </td>
                  <td class="item_amount_invoice text-right">
                    <!-- <span v-if="hasComma(item.item_org.price) === true">
                      {{ (removeComma(item.item_org.price) * item.quantity) }}
                    </span>
                    <span v-else> -->
                      {{ (item.item_org.price * item.quantity) | exchange_rate }}
                    <!-- </span > -->
                    <!-- == {{ item.item_amount}} -->
                    <p v-if="item.discount > 0" class="item-description">
                      - {{ item.discount | exchange_rate }}
                    </p>
                    <template
                      v-for="(op, op_index) in item.options"
                      class="item-description"
                    >
                      <p :key="op_index" class="item-description">---</p>
                      <template v-for="(opl, opl_index) in op.optionvalues">
                        <p
                          :key="opl_index + '__' + op_index"
                          class="item-description"
                        >
                          {{ (opl.price * item.quantity) | exchange_rate }}
                        </p>
                      </template>
                    </template>
                  </td>
                  <td
                    class="text-right invoice_edit"
                    @click="showEditItemsDialog(item)"
                  >
                    <icon icon="edit" class="icon-edits pointer" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </VuePerfectScrollbar>
        <!--end  table order -->
        <!-------------------------------------------------- total order    -->
        <table class="table">
          <tbody class="table-total">
            <tr>
              <td class style="text-transform: uppercase">
                {{ $t("Invoice") }} {{ $t("Number") }}:
              </td>
              <td v-if="order_modify.id" class="text-right">
                {{ order_modify.invoice_number }}
              </td>
              <td v-else class="text-right">
                {{ $t("New") }}
              </td>
            </tr>

            <tr>
              <td style="text-transform: uppercase">{{ $t("Type") }} :</td>
              <td class="text-right">
                <span class="order_type">{{ $t(order_type) }}</span>
              </td>
            </tr>
            <tr>
              <td>{{ $t("sub_total") }}:</td>
              <td class="text-right">
                {{ sub_total | exchange_rate }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("Discount") }}:</td>
              <td class="text-right">
                {{ discount | exchange_rate }}
              </td>
            </tr>
            <template v-if="restaurant.tax_type === 'EXCLUSIVE'">
              <tr>
                <td class>
                  {{ $t("Service Charge") }} {{ restaurant.service_charge }} % :
                </td>
                <td class="text-right">
                  {{
                    ((restaurant.service_charge * total) / 100) | exchange_rate
                  }}
                </td>
              </tr>

              <tr>
                <td class>{{ $t("Tax") }} {{ restaurant.tax }} %:</td>
                <td class="text-right">
                  {{ ((restaurant.tax * total) / 100) | exchange_rate }}
                </td>
              </tr>
              <tr>
                <td class>
                  {{ $t("Amount to be Paid") }}
                </td>
                <td class="text-right">
                  {{
                    ((restaurant.service_charge * total) / 100 +
                      (restaurant.tax * total) / 100 +
                      total / 1)
                      | exchange_rate
                  }}
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td class>{{ $t("Amount to be Paid") }}:</td>
                <td class="text-right">
                  {{ total | exchange_rate }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <!--------------------------------------------------end total order -->
        <!-- action-button -->
        <div class="action-pay">
          <button
            class="btn btn-order"
            :disabled="total == 0"
            style="min-width: 110px"
            @click="openConfirm('NO')"
          >
            <template v-if="is_new_order === true">
              {{ $t("save") }}
            </template>
            <template v-if="is_new_order === false">
              {{ $t("Modify") }}
            </template>
          </button>
          <button
            class="btn btn-order pay"
            :disabled="total == 0"
            :class="{ 'has-send': isPrintRoom }"
            @click="openConfirm('YES')"
          >
            {{ $t("Pay") }}
          </button>

          <button class="btn btn-order" @click="openModalDiscount()">
            {{ $t("Disc") }}
          </button>

          <button
            v-if="isPrintRoom == true"
            class="btn btn-order"
            @click="sendOrder()"
          >
            {{ $t("Send") }}
          </button>
        </div>

        <!-- end action button -->
      </div>
    </div>

    <!-- group modal -->
    <div v-if="modal_item" class="modal show_modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg-custom modal-lg">
        <div class="modal-content">
          <div class="modal-header" style="background: white; color: black">
            <div class="container">
              <button
                type="button"
                style="position: absolute"
                class="btn btn-small"
                @click="modal_item = false"
              >
                <v-icon>mdi-arrow-left</v-icon> {{ $t("Back") }}
              </button>
              <div class="text-center">
                <h4>{{ $t("Menu Detail") }} ({{ item_selected.title }})</h4>
              </div>
            </div>
          </div>

          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="center-flex group-tabs">
                    <button
                      class="btn btn-tab"
                      :class="[modal_item_select_tab === 1 ? 'show' : '']"
                      @click="modal_item_select_tab = 1"
                    >
                      {{ $t("Menu") }}
                    </button>
                    <button
                      v-if="item_selected.is_special == true"
                      class="btn btn-tab"
                      :class="[modal_item_select_tab === 2 ? 'show' : '']"
                      @click="modal_item_select_tab = 2"
                    >
                      {{ $t("Modify Price") }}
                    </button>
                    <button
                      class="btn btn-tab"
                      :class="[modal_item_select_tab === 3 ? 'show' : '']"
                      @click="modal_item_select_tab = 3"
                    >
                      {{ $t("Quantity") }}
                    </button>
                    <button
                      class="btn btn-tab"
                      :class="[modal_item_select_tab === 4 ? 'show' : '']"
                      @click="modal_item_select_tab = 4"
                    >
                      {{ $t("Discount") }}
                    </button>
                    <button
                      class="btn btn-tab"
                      :class="[modal_item_select_tab === 5 ? 'show' : '']"
                      @click="modal_item_select_tab = 5"
                    >
                      {{ $t("Note") }}
                    </button>
                  </div>
                </div>
                <div class="col-md-12">
                  <template v-if="modal_item_select_tab == 1">
                    <div class="row">
                      <div class="col-md-2 d-none d-sm-block">
                        <img
                          :src="item_selected.image"
                          class="img-fluid image-item"
                        />
                      </div>
                      <div class="col-md-4">
                        <h4 class="">
                          {{ item_selected.title }}
                        </h4>
                        <p class="">
                          {{ $t("Product Code") }} : {{ item_selected.code }}
                        </p>
                        <p>
                          {{ $t("Price") }} :
                          <strong>
                            {{ item_selected.price | exchange_rate }}</strong
                          >
                        </p>
                      </div>
                    </div>
                    <div
                      v-if="item_selected.options.length > 0"
                      class="wrap-option-item mt-2"
                    >
                      <div
                        v-for="(option, index) in item_selected.options"
                        :key="index"
                        class="card card-option-item m-1"
                      >
                        <!-- detail item  option -->
                        <h5 class="mb-2">
                          {{ option.title }}
                        </h5>
                        <div
                          v-for="opl in option.optionvalues"
                          :key="opl.id + opl.title"
                        >
                          <template v-if="option.type === 'Option'">
                            <label class="radio-app">
                              {{ opl.title }}
                              <input
                                :id="opl.title"
                                v-model="selected_options[index]"
                                type="radio"
                                :value="[
                                  option.id,
                                  opl.id,
                                  opl.price,
                                  option.title,
                                  opl.title,
                                ]"
                              />
                              <span class="radio-app-mark" />
                              <span class="float-right">{{
                                opl.price | exchange_rate
                              }}</span>
                            </label>
                          </template>
                          <template v-else>
                            <label class="checkbox-label">
                              <input
                                v-model="selected_checkbox"
                                type="checkbox"
                                :name="'group_' + option.title + option.id"
                                :value="[
                                  option.id,
                                  opl.id,
                                  opl.price,
                                  option.title,
                                  opl.title,
                                ]"
                              />
                              <span class="checkbox-mark" />
                              {{ opl.title }}
                              <span class="float-right">{{
                                opl.price | exchange_rate
                              }}</span>
                            </label>
                          </template>
                        </div>
                      </div>
                      <!-- End Menu Option -->
                    </div>
                  </template>
                  <template v-if="modal_item_select_tab == 2">
                    <div class="center-flex">
                      <div class="wrap-cal">
                        <p>
                          {{ $t("Price") }} :
                          <!-- <strong v-if="hasComma(item_selected.price) === true">
                            {{  this.exch.code + '  ' + item_selected.price }}
                            </strong> -->
                            <strong>
                            {{ item_selected.price | exchange_rate }}
                            </strong >
                        </p>
                        <div class="input-group" style="width: 100%">
                          <input
                            v-model="formatSetAndGetAmount"
                            type="text"
                            class="form-control"
                            style="
                              height: 60px;
                              text-align: right;
                              width: 10px;
                              font-size: 25px;
                            "
                          />
                          <div
                            class="input-group-append"
                            style="
                              height: 60px;
                              font-size: 25px;
                              text-align: right;
                            "
                          >
                            <span
                              class="input-group-text"
                              @click="(item_selected.price = 0), clearKeyPrice()"
                            >
                              <v-icon>mdi-close-circle</v-icon>
                            </span>
                          </div>
                        </div>
                        <key-pad-order
                          ref="keypad_amount"
                          :input="String(item_selected.price)"
                          input-name="keypad_price"
                          @onChange="onChangePrice"
                        />
                      </div>
                    </div>
                  </template>
                  <template v-if="modal_item_select_tab == 3">
                    <div class="center-flex">
                      <div class="wrap-cal">
                        <label for=""
                          >{{ $t("Quantity") }}: {{ item_quantity }}</label
                        >
                        <div class="input-group" style="width: 100%">
                          <input
                            v-model="item_quantity"
                            type="text"
                            class="form-control"
                            style="
                              height: 60px;
                              text-align: right;
                              width: 10px;
                              font-size: 25px;
                            "
                          />
                          <div
                            class="input-group-append"
                            style="
                              height: 60px;
                              font-size: 25px;
                              text-align: right;
                            "
                          >
                            <span
                              class="input-group-text"
                              @click="(item_quantity = 0), clearKeyQuantity()"
                            >
                              <v-icon>mdi-close-circle</v-icon>
                            </span>
                          </div>
                          <button
                            style="width: 70px; background: red"
                            class="btn btn-default ml-1"
                            @click="minusItemQuantity(false)"
                          >
                            <v-icon dark> mdi-minus-circle-outline </v-icon>
                          </button>
                          <button
                            style="width: 70px; background: #2e302d"
                            class="btn btn-default ml-1"
                            @click="plusItemQuantity(false)"
                          >
                            <v-icon dark> mdi-plus-circle-outline </v-icon>
                          </button>
                        </div>
                        <key-pad-order
                          ref="keypad_qty"
                          :input="String(item_quantity)"
                          input-name="keypad_qty"
                          @onChange="onChange"
                        />
                      </div>
                    </div>
                  </template>
                  <!-- discount -->
                  <template v-if="modal_item_select_tab == 4">
                    <div class="center-flex">
                      <div class="wrap-cal">
                        <label v-if="discount_item_is_amount == true" for=""
                          >{{ $t("Discount") }} :
                            <span v-if="item_discount_amount > item_selected.price">{{ item_selected.price | exchange_rate }}</span>
                            <span v-else>{{ item_discount_amount | exchange_rate }}</span>
                          </label
                        >
                        <label v-if="discount_item_is_amount == false" for=""
                          >{{ $t("Discount") }} :
                          {{ item_discount_amount + ' %' }}</label
                        >
                        <div class="input-group">
                          <div
                            class="input-group-append"
                            style="
                              position: absolute;
                              z-index: 9999;
                              margin-top: 10px;
                            "
                          >
                            <span class="mr-4">% </span>
                            <toggle-button
                              v-model="discount_item_is_amount"
                              :width="50"
                              :height="35"
                              @click.native="onChangeToggleDiscount()"
                            />
                            <span class="ml-4"> K </span>
                          </div>
                          <input
                            v-model="formatSetAndGetDiscount"
                            type="text"
                            class="input_discount form-control"
                          />

                          <div
                            class="input-group-append"
                            style="height: 60px; font-size: 25px"
                          >
                            <span
                              v-if="discount_item_is_amount == true"
                              class="input-group-text b0 bg0"
                            >
                              {{ selected_currency.code }}
                            </span>
                            <span v-else class="input-group-text b0 bg0">
                              %
                            </span>
                            <span
                              class="input-group-text"
                              style="border: none; background: no-repeat"
                              @click="onChangeDiscount(0)"
                            >
                              <v-icon>mdi-close-circle</v-icon>
                            </span>
                          </div>
                        </div>
                        <button
                          v-for="(btn, index) of shortcuts"
                          :key="index"
                          class="btn-shortcut"
                          @click="item_discount_amount = btn.value"
                        >
                          <span v-if="discount_item_is_amount == true">
                            {{ btn.value | commaNumber }}
                            {{ selected_currency.code }}</span
                          >
                          <span v-else> {{ btn.value }} % </span>
                        </button>

                        <key-pad-order
                          ref="keypad_discount"
                          :input="String(item_discount_amount)"
                          input-name="keypad_discount"
                          @onChange="onChangeDiscount"
                        />
                      </div>
                    </div>
                  </template>
                  <template v-if="modal_item_select_tab == 5">
                    <div class="center-flex">
                      <div class="wrap-cal">
                        <label for=""> {{ $t("Add Note on menu") }}</label>
                        <textarea
                          v-model="item_note"
                          class="form-control"
                          rows="5"
                          style="border: dashed 2px orange"
                        />
                      </div>
                    </div>
                  </template>
                </div>

                <div class="col-md-12 text-center">
                  <div class="mt-5">
                    <button
                      :disabled="item_quantity <= 0"
                      type="button"
                      class="btn button-add-item m-1"
                      @click.prevent="addItemToBasket()"
                    >
                      {{ $t(!item_form_add ? "update" : "Done") }}
                    </button>

                    <!-- {{ $t("delete") }} -->
                    <button
                      v-if="!item_form_add"
                      type="button"
                      class="btn button-delete m-1"
                      @click="delete_item()"
                    >
                      {{ $t("Delete Item") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
    <!--  -->
    <div
      v-if="modal_category"
      class="modal show_modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" style="border: none">
            <div class="container">
              <button
                type="button"
                style="position: absolute"
                class="btn btn-small"
                @click="modal_category = false"
              >
                <v-icon class=""> mdi-arrow-left </v-icon> {{ $t("Back") }}
              </button>
              <div class="text-center">
                <h5>{{ $t("Category") }}</h5>
              </div>
            </div>
          </div>

          <div class="modal-body height-auto pb-5">
            <button
              class="btn btn-category"
              @click.prevent="fn_getAllItems(), (modal_category = false)"
            >
              {{ $t("All Category") }}
            </button>
            <button
              v-if="meta_category.id > 0"
              class="btn btn-category"
              :class="{
                selectedCategory: selected_category.id === meta_category.id,
              }"
              @click="backButton(meta_category)"
            >
              <icon icon="arrow-left-circle" class="mr-2" />
              {{ meta_category.title }}
            </button>
            <button
              v-for="(cate, index) in parent_category"
              :key="index"
              class="btn btn-category"
              :class="{ selectedCategory: selected_category.id === cate.id }"
              @click="getChild(cate)"
            >
              {{ cate.title }}
            </button>
            <!-- <loading class="order-loading" v-if="loading"></loading> -->
          </div>
        </div>
      </div>
    </div>
    <!--  -->

    <div
      v-if="modal_table"
      class="modal show_modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg modal-lg-custom modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div class="container">
              <button
                type="button"
                style="position: absolute"
                class="btn btn-small text-white"
                @click="modal_table = false"
              >
                <v-icon class="text-white"> mdi-arrow-left </v-icon>
                {{ $t("Back") }}
              </button>
              <div class="text-center">
                <h5 v-if="order_type === 'walk_in'" class="text-center">
                  {{ $t("table") }}
                </h5>
                <h5 v-if="order_type === 'hotel_guest'" class="text-center">
                  {{ $t("Room") }}
                </h5>
              </div>
            </div>
          </div>

          <div class="modal-body">
            <base-table
              v-model="table_selected"
              :value="table_selected"
              @selected="flat_modal_table"
              @open_sale="openSaleFromTable"
            />
            <nodata
              v-if="!loading_table & (tables.length <= 0)"
              class="text-center"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- modal payment -->

    <div
      v-if="modal_confirm"
      class="modal show_modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg-custom modal-dialog-centered">
        <div class="modal-content" style="margin-top: 0px; height: 100vh">
          <div
            class="modal-header"
            style="background: white; border-bottom: 1px solid #eaeaea"
          >
            <div class="container">
              <button
                type="button"
                style="position: absolute"
                class="btn btn-small"
                @click="(modal_confirm = false), (container = 'PAYMENT')"
              >
                <v-icon class=""> mdi-arrow-left </v-icon>
                {{ $t("Back") }}
              </button>
              <div class="text-center" style="color: black">
                <h4>{{ $t("Payment") }}</h4>
              </div>
            </div>
          </div>
          <div class="modal-body" style="height: auto !important; margin: auto">
            <div class="wrap-payform">
              <!-- Menu Payment left -->
              <div class="lef-menu-wrap">
                <ul class="left-aside-paid">
                  <li
                    :class="{ active: container == 'PAYMENT' }"
                    @click="container = 'PAYMENT'"
                  >
                    <icon icon="hard-drive" />
                    <p>Payment</p>
                  </li>
                  <li
                    :class="{ active: container == 'CUSTOMER' }"
                    @click="container = 'CUSTOMER'"
                  >
                    <icon icon="user" />
                    <p>Customer</p>
                  </li>
                  <li
                    :class="{ active: container == 'NOTE' }"
                    @click="container = 'NOTE'"
                  >
                    <icon icon="edit-2" />
                    <p>Note</p>
                  </li>
                  <li>
                    <toggle-button
                      v-model="print_preview"
                      :width="70"
                      :height="30"
                      :labels="{ checked: 'Print', unchecked: 'Off' }"
                    />
                    <p class="mt-2">
                      {{ $t("Print Order") }}
                    </p>
                  </li>
                </ul>
              </div>

              <div
                v-if="container == 'PAYMENT' && is_paid == 'NO'"
                class="container box-payform-inside"
              >
                <div class="d-flex justify-content-center">
                  <button
                    v-if="!save_order_loading"
                    class="btn btn-block shadow-sm btn-confirm mt-5"
                    style="max-width: 300px"
                    @click="submitOrder(false)"
                  >
                    <span v-if="is_new_order === true"> {{ $t("Save") }}</span>
                    <span v-if="is_new_order === false">
                      {{ $t("Modify") }}</span
                    >
                  </button>
                  <button
                    v-if="save_order_loading"
                    class="btn btn-block shadow-sm btn-confirm mt-5"
                    style="max-width: 300px; cursor: not-allowed"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    />
                    {{ $t("Save") }}...
                  </button>
                </div>
              </div>

              <!-- PAYMENT TAB -->
              <div
                v-if="container == 'PAYMENT' && is_paid == 'YES'"
                class="container box-payform-inside"
              >
                <div class="d-flex justify-content-center">
                  <div class="w-50 right mr-5" style="max-width: 400px">
                    <h6 class="mt-4 mb-4">
                      {{ $t("Cash Received") }}
                    </h6>
                    <!-- cash receive list  -->
                    <div
                      v-for="(currency, index_currency) of allExchange"
                      :key="index_currency + '12131'"
                    >
                      <div class="d-flex mb-2">
                        <div class="ml-2 input-group">
                          <input
                            :id="`name-${currency.code}`"
                            :value="formatCurrency(currency.cash_enter)"
                            @input="updateFormattedCurrency(index_currency, $event)"
                            type="text"
                            class="form-control"
                            min="0"
                            :placeholder="currency.code"
                            style="font-size: 25px"
                            @click="index_all_exchange = index_currency"
                            @keypress="isNumber($event)"
                          />
                          <div
                            class="input-group-prepend"
                            @click="currency.cash_enter = ''"
                          >
                            <span class="input-group-text">
                              <v-icon :size="30">mdi-close-circle</v-icon></span
                            >
                          </div>
                        </div>
                      </div>
                      <!-- <p class=" ml-2" v-if="currency.default == false" >   1  {{ base_currency.code}} =  {{ currency.rate}}  {{ currency.code  }}  </p>   -->
                    </div>

                    <!-- keypad  -->
                    <button
                      v-for="(btn, index) of shortcutAmounts"
                      :key="index"
                      class="btn-shortcut mt-4"
                      @click="setAmountBySort(btn.value, index_all_exchange)"
                    >
                      {{ btn.value }} {{ allExchange[index_all_exchange].code }}
                    </button>

                    <key-pad-order
                      ref="key-pad-cash-change"
                      :input="cashEnter"
                      input-name="cash_change"
                      @onChange="keyNumberChangeAmount"
                    />
                  </div>

                  <div class="w-50 left" style="max-width: 400px">
                    <h6 class="mt-3">
                      {{ $t("Amount to paid") }}
                    </h6>
                    <div class="d-flex mb-5 mt-4">
                      <div
                        class="text-center w-50"
                        style="border-right: 1px solid"
                      >
                        <h4>
                          <strong>
                            {{ selected_currency.code }}
                            {{
                              finalPay
                                | commaNumberRate(
                                  selected_currency.rate,
                                  selected_currency.code
                                )
                            }}
                          </strong>
                        </h4>
                      </div>
                      <div class="w-50 text-center">
                        <span
                          v-for="(currency, index_currency) of allExchange"
                          :key="index_currency"
                        >
                          <span v-if="currency.code != selected_currency.code">
                            <h4>
                              {{ currency.code }}
                              {{
                                finalPay
                                  | commaNumberRate(
                                    currency.rate,
                                    currency.code
                                  )
                              }}
                            </h4>
                          </span>
                        </span>
                      </div>
                    </div>

                    <!-- Change Currency -->
                    <h6 v-if="cash_change < 0" class="mt-2">
                      {{ $t("Balance") }}
                    </h6>
                    <h6 v-else class="mt-2">
                      {{ $t("Change") }}
                    </h6>
                    <div class="d-flex mb-4 mt-2">
                      <div
                        class="w-50 text-center"
                        style="border-right: 1px solid"
                      >
                        <h4>
                          <strong>
                            {{ selected_currency.code }}
                            {{
                              cash_change
                                | commaNumberRate(
                                  selected_currency.rate,
                                  selected_currency.code
                                )
                            }}
                          </strong>
                        </h4>
                      </div>
                      <div class="w-50 text-center">
                        <span
                          v-for="currency of restaurant.currencies"
                          :key="currency.code"
                        >
                          <span v-if="currency.code != selected_currency.code">
                            <h4>
                              {{ currency.code }}
                              {{
                                cash_change
                                  | commaNumberRate(
                                    currency.rate,
                                    currency.code
                                  )
                              }}
                            </h4>
                          </span>
                        </span>
                      </div>
                    </div>

                    <!-- button paymnet type -->
                    <div class="option-type-wrap mb-2">
                      <button
                        v-for="(type, index) of paymentTypes"
                        :key="index"
                        class="btn btn-option-type"
                        :class="{ active: payment_type.id == type.id }"
                        :style="{
                          height: '60px',
                        }"
                        @click="getPaymentType(type)"
                      >
                        {{ type.title }}
                      </button>
                      <button
                        v-if="isAllowCredit == true"
                        class="btn btn-option-type"
                        :style="{
                          height: '60px',
                        }"
                        @click="(payment_type = creditOption), makeCredit()"
                      >
                        {{ $t("Credit") }}
                      </button>
                    </div>

                    <button
                      class="btn btn-block btn-confirm mt-2"
                      @click="exact()"
                    >
                      {{ $t("Exact") }}
                    </button>

                    <!-- Check out btn -->
                    <template v-if="!loading_order">
                      <template
                        v-if="this.isAllowCredit == true && this.cash_change < 0"
                      >
                        <button
                          v-if="is_paid == 'YES'"
                          :disabled="ValidCheckOut == false"
                          class="btn btn-block shadow-sm btn-confirm"
                          @click="openModalCredit()"
                        >
                          {{ $t("Check Out") }}
                        </button>
                      </template>
                      <template v-else>
                        <button
                          v-if="is_paid == 'YES'"
                          :disabled="ValidCheckOut == false"
                          class="btn btn-block shadow-sm btn-confirm"
                          @click="submitOrder(false)"
                        >
                          {{ $t("Check Out") }}
                        </button>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
              <!-- END PAYMENT TAB -->

              <!-- CUSTOMER TAB -->
              <div
                v-if="container == 'CUSTOMER'"
                class="container box-payform-inside"
              >
                <div class="d-flex justify-content-center">
                  <div class="p-5" style="width: 100%; max-width: 700px">
                    <div class="row">
                      <label class="col-sm-2 col-form-label" />
                      <div class="col-sm-10">
                        <button
                          type="button"
                          class="btn btn-option-type"
                          @click="modal_customer = true"
                        >
                          <icon icon="user-plus" /> {{ $t("Select customer") }}
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-sm-2 col-form-label">
                        {{ $t("Customer") }}</label
                      >
                      <div class="col-sm-10">
                        <input
                          v-model="customer.name"
                          type="text"
                          readonly
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-sm-2 col-form-label">
                        {{ $t("Email") }}</label
                      >
                      <div class="col-sm-10">
                        <input
                          v-model="customer.email"
                          type="text"
                          readonly
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-sm-2 col-form-label">
                        {{ $t("Phone") }}</label
                      >
                      <div class="col-sm-10">
                        <input
                          v-model="customer.phone"
                          type="text"
                          readonly
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-sm-2 col-form-label" />
                      <div class="col-sm-10">
                        <toggle-button
                          v-model="send_email_to_customer"
                          class="float-right"
                          :width="120"
                          :height="35"
                          :labels="{
                            checked: $t('Send_Email'),
                            unchecked: $t('No send email'),
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--END CUSTOMER TAB -->

              <!-- NOTE TAB -->
              <div
                v-if="container == 'NOTE'"
                class="container box-payform-inside"
              >
                <div class="d-flex justify-content-center">
                  <textarea
                    v-model="order_note"
                    class="form-control mb-4 mt-4"
                    rows="8"
                    :placeholder="$t('Add Note on order')"
                    style="border: dashed 2px orange"
                  />
                </div>
              </div>
              <!-- END NOTE TAB -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ---------------- modal discount------------- -->
    <div
      v-if="modal_discount == true"
      class="modal show_modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg-custom modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" style="background: white; color: black">
            <div class="container">
              <button
                type="button"
                style="position: absolute"
                class="btn btn-small"
                @click="modal_discount = false"
              >
                <v-icon>mdi-arrow-left</v-icon> {{ $t("Back") }}
              </button>
              <div class="text-center">
                <h4>{{ $t("Discount") }}</h4>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="center-flex group-tabs">
                    <button
                      class="btn btn-tab"
                      :class="[discount_selected === 'amount' ? 'show' : '']"
                      @click="
                        (discount_selected = 'amount'), (discount_value = 0), (status_code = 200), (discount_item_is_amount = true)
                      "
                    >
                      {{ $t("Amount") }} ({{ selected_currency.code }})
                    </button>

                    <button
                      class="btn btn-tab"
                      :class="[discount_selected === 'percent' ? 'show' : '']"
                      @click="
                        (discount_selected = 'percent'), (discount_value = 0), (status_code = 200), (discount_item_is_amount = false)
                      "
                    >
                      {{ $t("Percent") }} (%)
                    </button>

                    <button
                      class="btn btn-tab"
                      :class="[discount_selected === 'code' ? 'show' : '']"
                      @click="
                        (discount_selected = 'code'), (discount_value = null), (status_code = 0)
                      "
                    >
                      {{ $t("PromoCode") }}
                    </button>
                  </div>
                </div>

                <div class="col-md-12 d-flex justify-content-center">
                  <div class="center-flex width-sm">
                    <div class="wrap-cal" style="width: 100% !important">
                      <div class="p-2">
                        <label for="discount">
                          {{ $t(discount_selected) }}</label
                        >
                        <input
                          v-if="discount_selected !== 'code'"
                          id="discount"
                          :value="formatDiscount(discount_value)"
                          @input="updateFormattedDiscount($event)"
                          type="text"
                          class="form-control"
                        />
                        <textarea
                          v-else
                          v-model="discount_value"
                          class="form-control"
                          rows="3"
                          style="border: dashed 2px orange"
                        />
                        <div
                          v-if="discount_selected === 'code'"
                          class="">
                          <div class=" mt-2 alert alert-success" v-if="promotion_obj.type != null">
                              <h6 >{{"" + promotion_obj.title + ' (' + promotion_obj.apply_to + ')'}} </h6>
                              <p v-if="promotion_obj.type == 'PERCENTAGE'">{{"Promotion Amount: " + promotion_obj.promotion_value + '%'}}</p>
                              <p v-if="promotion_obj.type == 'FIXED_AMOUNT'">{{"Promotion Amount: " + promotion_obj.promotion_value + 'KIP'}} </p>
                              <p v-if="promotion_obj.type == 'FREE_DELIVERY'">{{"Promotion Amount: " + promotion_obj.promotion_value + 'KIP'}} </p>
                              <p>{{"Expire Date: " + promotion_obj.date_to}} </p>
                          </div>

                          <button
                            class="w-25 btn button-check-code d-flex justify-content-center align-items-center"
                            :disabled='discount_value === null'
                            @click="applyDiscountCheck()"
                          >
                            <loading-small class="mr-1" v-if="loading_check_promotion_code" />
                            {{ $t("Check Code") }}
                          </button>
                        </div>
                      </div>

                      <template
                        v-if="
                          discount_selected == 'amount' ||
                          discount_selected == 'percent'
                        "
                      >
                        <button
                          v-for="(btn, index) of shortcuts"
                          :key="index"
                          class="btn-shortcut"
                          @click="discount_value = btn.value"
                        >
                          <span v-if="discount_item_is_amount == true">
                            {{ btn.value | commaNumber }}
                            {{ selected_currency.code }}</span
                          >
                          <span v-else> {{ btn.value }} % </span>
                        </button>
                      </template>
                      <key-pad-order
                        v-if="discount_selected == 'amount'"
                        ref="key-pad-discount-order-amount"
                        :input="String(discount_value)"
                        input-name="amount"
                        @onChange="discountOrderOnChanage"
                      />
                      <key-pad-order
                        v-if="discount_selected == 'percent'"
                        ref="key-pad-discount"
                        :input="String(discount_value)"
                        input-name="discount"
                        @onChange="discountOrderOnChanage"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-12 text-center">
                  <!-- <button @click="modal_discount = !modal_discount"  class="btn btn-close mr-2">   {{ $t("Close") }} </button>               -->
                  <button
                    class="btn button-clear-item mt-5 mx-2"
                    @click="applyDiscount()"
                    :disabled='discount_value === null || status_code == 404 || status_code == 0'
                  >
                    <loading-small v-if="loading_apply_promotion_code" />
                    {{ $t("Apply") }}
                  </button>

                  <button
                    class="btn button-clear-item mt-5 mx-2"
                    @click="clearPromoteCode()"
                    v-if="discount_selected === 'code'"
                  >
                    {{ $t("Clear Promotion Code") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  -->

    <base-modal
      v-model="modal_alert_print_qty"
      modal="modal-lg noprint"
      body="height:300px;"
    >
      <template v-slot:body>
        <div class="text-center mt-5 mb-5">
          <h5>{{ $t("Menu is sent to print room ready!") }}</h5>
        </div>
        <div class="text-center mt-5">
          <button
            class="btn btn-primary p-4"
            @click="agreeQtyPrint(), (modal_alert_print_qty = false)"
          >
            {{ $t("continue") }}
          </button>
          <button
            class="btn btn-secondary p-4 ml-2"
            @click="modal_alert_print_qty = false"
          >
            {{ $t("Close") }}
          </button>
        </div>
      </template>
    </base-modal>

    <!-- modal customer -->
    <div
      v-if="modal_customer"
      class="modal show_modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content" style="margin-top: -20px; height: 97vh">
          <!-- <div class="modal-header">
            <div class="container">
              <button
                type="button"
                style="position: absolute"
                @click="modal_customer = false"
                class="btn btn-small"
              >
                <v-icon class="">mdi-arrow-left</v-icon>
                {{ $t("Back") }}
              </button>
              <div class="text-center">
                <h4>{{ $t("Select") }} {{ $t("Customer") }}</h4>
              </div>
            </div>
          </div> -->
          <div class="modal-body modal-body-custom">
            <form class="" @submit.prevent="getCustomer">
              <div class="input-group">
                <div
                  class="input-group-append pointer"
                  @click="modal_customer = false"
                >
                  <span class="input-group-text">
                    <v-icon class="">mdi-arrow-left</v-icon>
                    {{ $t("Back") }}
                  </span>
                </div>

                <input
                  v-model="model_customer.search"
                  type="text"
                  class="form-control"
                  :placeholder="$t('Find by name, email, phone number.')"
                  @keyup="getCustomer()"
                />
                <div class="input-group-append pointer" @click="getCustomer">
                  <span class="input-group-text">
                    <icon icon="search" />
                  </span>
                </div>

                <div
                  class="input-group-append pointer"
                  @click="modal_create_customer = true"
                >
                  <span class="input-group-text">
                    {{ $t("Create Customer") }}
                  </span>
                </div>
              </div>
            </form>

            <VuePerfectScrollbar class="customer-wrap mt-2">
              <div
                class="shadow-sm mb-2 p-2"
                style="width: 98%"
                @click="setCustomer({ id: 0, name: $t('none') })"
              >
                <div class="row">
                  <div class="col-4">
                    <p>
                      <strong> {{ $t("Default") }}</strong>
                    </p>
                  </div>
                </div>
              </div>

              <div
                v-for="(cust, index) in customers"
                :key="index"
                class="shadow-sm mb-2 p-2"
                style="width: 98%"
                :class="{ customer_selected: cust.id === customer.id }"
                @click="setCustomer(cust)"
              >
                <div class="row">
                  <div class="col-4">
                    <p>
                      <strong> {{ cust.name }}</strong>
                    </p>
                    <p>#: {{ cust.id }}</p>
                  </div>
                  <div class="col-8">
                    <p>
                      <icon icon="smartphone" :size="15" /> ​{{
                        cust.phone || "none"
                      }}
                    </p>
                    <p>
                      <icon icon="mail" :size="15" /> {{ cust.email || "none" }}
                    </p>
                  </div>
                </div>
              </div>
              <loading v-if="loading_customer" />
              <nodata
                v-if="(customers.length < 1) & !loading_customer"
                class="text-center"
              />

              <div
                v-if="(customers.length < 1) & !loading_customer"
                class="button_create customer text-center"
              >
                <button
                  class="btn btn-default"
                  @click="modal_create_customer = true"
                >
                  {{ $t("Create Customer") }}
                </button>
              </div>
            </VuePerfectScrollbar>
          </div>
          <div class="modal-footer text-center">
            <p-pagination
              v-model="model_customer.page"
              class="pull-center mr-auto"
              :per-page="Number(meta_customers.per_page)"
              :page-count="meta_customers.last_page"
              :total="meta_customers.total"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="modal_create_customer"
      class="modal show_modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div class="container">
              <button
                type="button"
                style="position: absolute"
                class="btn btn-small"
                @click="modal_create_customer = false"
              >
                <v-icon class=""> mdi-arrow-left </v-icon>
                {{ $t("Back") }}
              </button>
              <div class="text-center">
                <h4>{{ $t("Create Customer") }}</h4>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <base-customer v-model="customer" @saved="customerSave" />
          </div>
        </div>
      </div>
    </div>
    <!-- end group modal -->
  </div>
</template>

<style lang="css">
  .customer-wrap {
    height: calc(100vh - 157px);
  }

  .form-custom {
    margin-bottom: 5px;
  }
</style>

<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import Swal from "sweetalert2";
  import store from "@/store";
  import { addListener } from "process";
  import { roundNumber } from '@/utils/helper'
  const _ = require("lodash");

  export default {
    name: "Order",
    layout: "cashier",
    middleware: ["auth", "order_type", "payment_type"],
    components: {
      VuePerfectScrollbar,
    },
    data: () => ({
      // payment modal
      container: "PAYMENT",
      allExchange: [],
      index_all_exchange: 0,
      payment_type: {},
      discount_item_is_amount: false,
      modal_invoice_preview: false,
      modal_item_select_tab: 1,
      modal_alert_print_qty: false,
      modal_alert_print_delete: false,
      modal_discount: false,
      mobile_screen: false,
      modal_item: false,
      modal_customer: false,
      modal_create_customer: false,
      modal_table: false,
      modal_confirm: false,
      modal_category: false,
      mobile_cart: false,
      is_new_order: true,
      table_selected: {
        id: 0,
        name: "",
      },
      customer_tmp: {},
      customer: {
        id: 0,
        name: "",
      },
      model_customer: {
        page: 1,
        limit: 10,
        search: "",
        type: "restaurant",
        type_id: 0,
      },
      cash_receive: 0,
      search_item: "",
      is_paid: "",
      list_items: {},
      invoice: [],
      selected_options: [],
      selected_checkbox: [],
      edit_item_invoice: [],
      send_email_to_customer: false,
      coupon_id: null,
      coupon_price: "0.00",
      coupon_code: "",
      price: 0,
      item_quantity: 1,
      order_quantity: 0,
      discount: 0,
      parent_category: [],
      meta_category: {},
      selected_category: {
        id: 0,
      },
      removed_sale_details: [],
      edit_item_amount: 0,
      item_selected: {},
      item_form_add: false,
      next_page: 1,
      category: [],
      remark_order_status: false,
      button_note: false,
      item_note: "",
      order_note: "",
      category_text: "All Items",
      discount_selected: "amount",
      discount_value: 0,
      item_discount_percent: 0,
      item_discount_amount: 0,
      tab_confirm: "",
      print_preview: true,
      order_print: {},
      creditOption: {},
      paymentTypes: [],
      save_order_loading: false,
      promotion_obj: {},
      promotion: 0,
      status_code: 0,
    }),
    computed: {
      formatSetAndGetAmount: {
        get() {
          // Use a regular expression to add commas as a thousand separator
          return this.item_selected.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        set(value) {
          // Remove commas and update the original data
          this.item_selected.price = value.replace(/,/g, '') || 0;
        },
      },
      formatSetAndGetDiscount: {
        get() {
          // Use a regular expression to add commas as a thousand separator
          if(this.item_discount_amount > this.item_selected.price && this.discount_item_is_amount === true) {
            return this.item_selected.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          } 

          if(this.discount_item_is_amount === false && this.item_discount_amount > 100) {
            return this.item_discount_amount = 100;
          }
          return this.item_discount_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');    
        },
        set(value) {
          // Remove commas and update the original data
          this.item_discount_amount = value.replace(/,/g, '') || 0;
        },
      },
      cashEnter() {
        if (this.allExchange[this.index_all_exchange]) {
          return this.allExchange[this.index_all_exchange].cash_enter.toString();
        }
        return "";
      },

      ValidCheckOut() {
        if (this.isAllowCredit == false && this.cash_change >= 0) return true;
        if (this.isAllowCredit == true && this.totalCashEnter > 0) {
          return true;
        }
        return false;
      },

      credit() {
        let find = _.find(this.restaurant.payment_type, function (obj) {
          return obj.code == "CREDIT";
        });
        return find;
      },

      isAllowCredit() {
        let find = _.find(this.restaurant.payment_type, function (obj) {
          return obj.code == "CREDIT";
        });

        if (find) {
          this.creditOption = find;
          return true;
        }
        return false;
      },

      finalPay() {
        let paid = 0;
        if (this.order_modify.id) {
          paid = this.order_modify.amount_paid;
        }
        if (this.restaurant.tax_type === "EXCLUSIVE")
          return (
            (this.restaurant.service_charge * this.total) / 100 +
            (this.restaurant.tax * this.total) / 100 +
            this.total / 1 -
            paid
          );
        console.log("paid", paid);

        return this.total - paid;
      },
      shortcutAmounts() {
        let vm = this;
        let { amount } = store.getters["restaurant/shortcut"];
        if (amount.length < 1) return [];

        let tmp = _.filter(amount, function (o) {
          return o.currency_code == vm.allExchange[vm.index_all_exchange]?.code;
        })[0];

        if (!tmp) return [];
        return tmp.amount;
      },
      shortcuts() {
        let vm = this;
        let { discount_percentage, discount_amount } =
          store.getters["restaurant/shortcut"];
        if (vm.discount_item_is_amount == true) {
          let tmp = _.filter(discount_amount, function (o) {
            return o.currency_code == vm.selected_currency.code;
          })[0];
          if (tmp) return tmp.amount;
        }
        let data = [];
        if (discount_percentage)
          discount_percentage.forEach((el) => {
            data.push({ value: el.amount_value });
          });
        return data;
      },
      base_currency() {
        return store.getters["currency/base_currency"];
      },
      loading_customer() {
        return store.getters["customer/loading"] || false;
      },
      loading_apply_promotion_code() {
        return store.getters["order/loading_apply_promotion_code"] || false;
      },
      loading_check_promotion_code() {
        return store.getters["order/loading_check_promotion_code"] || false;
      },
      meta_customers() {
        return store.getters["customer/meta"] || [];
      },
      customers() {
        return store.getters["customer/customers"] || [];
      },
      loading_table() {
        return store.getters["location/loading"];
      },
      tables() {
        return store.getters["location/parent_location"] || [];
      },
      loading_order() {
        return store.getters["order/loading_order"];
      },
      cash_change() {
        let paid = 0;
        if (this.order_modify.id) {
          paid = this.order_modify.amount_paid;
        }
        if (this.restaurant.tax_type === "EXCLUSIVE") {
          let total_ =
            (this.restaurant.service_charge * this.total) / 100 +
            (this.restaurant.tax * this.total) / 100 +
            this.total / 1;
          return this.totalCashEnter - (total_ - paid);
        }
        return this.totalCashEnter - (Number(this.total) - paid);
      },

      totalCashEnter() {
        var total = 0;
        this.allExchange.forEach((item) => {
          total += item.cash_enter / item.rate;
        });
        return total;
      },

      loading() {
        return store.getters["order/loading"];
      },

      loading_more() {
        return store.getters["order/loading_more"];
      },

      selected_currency() {
        return store.getters["currency/selected_currency"];
      },

      currencies() {
        return store.getters["auth/currencies"];
      },

      items() {
        return store.getters["order/items"];
      },
      items_length() {
        return store.getters["order/items_length"];
      },
      order_items() {
        return store.getters["order/order_items"];
      },
      meta_item() {
        return store.getters["order/meta"];
      },
      sub_total() {
        return this.order_items.reduce(
          (acc, item) => (acc += item.item_amount),
          0
        );
      },
      total_items() {
        let order = this.order_items;
        return order.reduce((acc, item) => (acc += item.quantity), 0);
      },
      total() {
        return (this.sub_total - this.discount).toFixed(2);
      },
      categories() {
        return store.getters["category/category"];
      },
      coupon_amount() {
        return store.getters["order/coupon_amount"];
      },
      order_status() {
        return store.getters["order/order_status"];
      },
      sale() {
        return store.getters["order/sale"];
      },
      order_preview() {
        return store.getters["order/order"];
      },
      order_type() {
        return store.getters["order/order_type"];
      },
      restaurant() {
        return store.getters["restaurant/restaurant"];
      },
      editCustomer() {
        if (this.customer.id > 0) {
          return true;
        } else {
          return false;
        }
      },
      validate_selected_table() {
        let disable = true;
        if (
          this.order_type === "walk_in" ||
          this.order_type === "hotel_guest"
        ) {
          if (this.table_selected.id <= 0) {
            disable = true;
          } else {
            disable = false;
          }
        } else {
          disable = false;
        }
        return disable;
      },
      order_modify() {
        return store.getters["order/order_modify"];
      },
      isPrintRoom() {
        return process.env.VUE_APP_AVAIBLE_PRINT_ORDER_TO_ROOM === "true";
      },
      exch() {
        return store.getters["currency/selected_currency"];
      }
    },
    watch: {
      item_discount_amount: function (value) {
        this.item_discount_amount = Number(value);
      },
      item_quantity: function (value) {
        this.item_quantity = Number(value);
      },
      cash_receive: function (value) {
        // this.cash_receive = Number(value);
      },
      modal_confirm: function (value) {
        this.tab_confirm = "";
      },
      item_discount_percent: function (value) {
        if (value > 100) {
          this.item_discount_percent = 100;
        }
      },
      discount_value: function (value) {
        if (this.discount_selected === "amount" && value > this.sub_total) {
          this.discount_value = this.sub_total;
        }
        if (this.discount_selected === "percent" && value > 100) {
          this.discount_value = 100;
        }
      },
      sub_total: function (value) {
        if (this.discount_selected === "code" && this.discount_value !== null) {
          this.applyDiscount();
        }
      },
    },

    mounted() {
      this.fn_getAllItems();
      this.getCategories();
      this.list_items = this.items;
      this.setModifyToOrder();
      this.$store.dispatch("auth/firestore_init");

      if (this.$route.query.table == true && this.order_type === "walk_in") {
        this.showModalTable();
      }

      this.payment_type = this.restaurant.payment_type[0];

      this.restaurant.payment_type.forEach((v) => {
        // this.paymentTypes.push(v);
        if (v.title != "Credit") this.paymentTypes.push(v);
      });

      // ✅ FIX START HERE
      this.allExchange = [];

      let currencies = this.restaurant.payment_type[0].currencies;

      if (Array.isArray(currencies)) {
        currencies.forEach((item) => {
          this.allExchange.push({
            cash_enter: "",
            cash_change: 0,
            ...item,
          });
        });
      } else if (currencies && typeof currencies === "object") {
        Object.values(currencies).forEach((item) => {
          this.allExchange.push({
            cash_enter: "",
            cash_change: 0,
            ...item,
          });
        });
      }
      // ✅ FIX END HERE
    },
    methods: {
      isNumber(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      getPaymentType(type) {
        this.allExchange = [];
        this.index_all_exchange = 0;

        let all_currency = _.find(this.restaurant.payment_type, (o) => {
          return o.title == type.title;
        });

        if (!all_currency || !all_currency.currencies) return;

        let currencies = all_currency.currencies;

        // ✅ FIX SUPPORT BOTH OBJECT + ARRAY
        if (Array.isArray(currencies)) {
          currencies.forEach((item) => {
            this.allExchange.push({
              cash_enter: "",
              cash_change: 0,
              ...item,
            });
          });
        } else {
          Object.values(currencies).forEach((item) => {
            this.allExchange.push({
              cash_enter: "",
              cash_change: 0,
              ...item,
            });
          });
        }

        this.payment_type = type;
      },
      formatCurrency(value) {
          if(value != 0) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          } else {
            return '';
          }
      },
      updateFormattedCurrency(index, event) {
        this.allExchange[index].cash_enter = event.target.value.replace(/,/g, '') || 0;
      },
      formatDiscount(value) {
          if(value != 0) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          } else {
            return 0;
          }
      },
      updateFormattedDiscount(event) {
        this.discount_value = event.target.value.replace(/,/g, '') || 0;
      },
      setAmountBySort(value, index) {
        this.allExchange[index].cash_enter =
          Number(value) + Number(this.allExchange[index].cash_enter);
      },
      keyNumberChangeAmount(input) {
        if (this.index_all_exchange < 0) {
          this.index_all_exchange = 0;
        }
        this.allExchange[this.index_all_exchange].cash_enter = input;
      },

      discountOrderOnChanage(input) {
        this.discount_value = input;
      },
      onChangeToggleDiscount() {
        this.item_discount_amount = 0;
        this.$refs.keypad_discount.clearInput(0);
      },
      clearKeyQuantity() {
        this.$refs.keypad_qty.clearInput(0);
      },
      clearKeyPrice() {
        this.$refs.keypad_price.clearInput(0);
      },
      onChangeDiscount(input) {
        if (input > 100 && this.discount_item_is_amount == false) {
          this.$refs.keypad_discount.clearInput(0);
          return 100;
        }
        this.item_discount_amount = input;
      },
      onChange(input) {
        this.item_quantity = input ;
      },
      onChangePrice(input) {
        this.item_selected.price = input;
      },
      onKeyPress(button) {},
      agreeQtyPrint() {
        if (this.modal_alert_print_delete == true) {
          this.delete_item(true);
        } else {
          this.addItemToBasket(true);
        }
      },
      openModalDiscount() {
        this.modal_discount = true;
        this.discount_value = store.getters["order/tmp_promo_code"];
        // this.discount_selected = "amount";
        if(this.discount_selected == "amount") {
          this.discount_value = 0;
          this.status_code = 200;
        }
        if(this.discount_selected == "code") {
          this.discount_value = null;
          this.status_code = 0;
        }

        if(this.discount_selected == "percent") {
          this.discount_value = 0;
          this.status_code = 200;
        }
        this.promotion_obj = {}
        if (this.order_modify.promotion_code) {
          this.discount_selected = "code";
          this.discount_value = this.order_modify.promotion_code;
        }
      },
      customerSave(saved) {
        if (saved === true) {
          this.modal_customer = false;
          this.modal_create_customer = false;
        }
      },
      setModifyToOrder() {
        if (this.order_modify.id) {
          this.is_new_order = false;
          this.$store.dispatch("order/clear_order");
          this.$store.dispatch(
            "order/setOrderType",
            this.order_modify.order_type
          );
          if (this.order_modify.customer) {
            this.customer = this.order_modify.customer;
          }
          if (this.order_modify.table) {
            this.table_selected = this.order_modify.table;
          }
          let vm = this;
          vm.discount = this.order_modify.discount;
          if (this.order_modify.percentage) {
            this.discount_selected = "percent";
            this.discount_value = this.order_modify.percentage;
          }

          if (this.order_modify.promotion_code) {
            this.discount_selected = "code";
            this.discount_value = this.order_modify.promotion_code;
          }

          this.$store.dispatch("order/clearTmpPromoCode");

          let sale_details = this.order_modify.sale_details || [];
          for (var k = 0; k < sale_details.length; k++) {
            let detail = sale_details[k];
            let data_detail = {
              options: [],
              item_key: detail.venueitem.id,
              item_old_key: detail.venueitem.id,
              item_id: detail.venueitem.id,
              item_org: detail.venueitem,
              item_price_per_set: Number(detail.venueitem.price),
              item_amount: Number(detail.venueitem.price),
              quantity: detail.qty,
              sale_detail_id: detail.id,
              quantity_print: detail.print_qty,
              discount: detail.discount,
              item_discount_percent: detail.percentage,
              item_discount_amount: 0,
            };

            let detail_options = detail.options || [];

            // -------------update status modal-------------
            data_detail.key_selected_option = [];
            data_detail.key_selected_check_box = [];
            let org_item_options = detail.venueitem.options || [];

            org_item_options.forEach(function (org_option) {
              if (org_option.type === "CheckBox") {
                let has_option = _.find(
                  detail_options,
                  function (detail_option) {
                    return org_option.id === detail_option.option_id;
                  }
                );
                if (has_option) {
                  let option_values = has_option.option_optionvalue || [];
                  option_values.forEach(function (option_value) {
                    let key = [
                      org_option.id,
                      option_value.optionvalue_id,
                      option_value.optionvalue_price,
                      org_option.title,
                      option_value.optionvalue_title,
                    ];
                    data_detail.key_selected_check_box.push(key);
                  });
                }
                data_detail.key_selected_option.push(null);
              }
              if (org_option.type === "Option") {
                let has_option = _.find(
                  detail_options,
                  function (detail_option) {
                    return org_option.id === detail_option.option_id;
                  }
                );
                if (has_option) {
                  let option_values = has_option.option_optionvalue || [];
                  option_values.forEach(function (option_value) {
                    let key = [
                      org_option.id,
                      option_value.optionvalue_id,
                      option_value.optionvalue_price,
                      org_option.title,
                      option_value.optionvalue_title,
                    ];
                    data_detail.key_selected_option.push(key);
                  });
                }
              }
            });

            // --------------------------

            detail_options.forEach(function (option) {
              let data = {
                option_id: option.option_id,
                title: option.title,
                optionvalues: [],
                type: option.type,
              };
              let detail_option_values = option.option_optionvalue || [];
              let option_values = [];
              detail_option_values.forEach(function (option_value) {
                option_values.push({
                  option_value_id: option_value.optionvalue_id,
                  price: option_value.optionvalue_price,
                  title: option_value.optionvalue_title,
                });
                data_detail.item_key =
                  data_detail.item_key +
                  "_" +
                  option_value.option_id +
                  "_" +
                  option_value.optionvalue_id;
              });
              data.optionvalues = _.sortBy(option_values, "option_value_id");
              option_values.forEach(function (optionValue) {
                data_detail.item_amount =
                  Number(data_detail.item_amount) + Number(optionValue.price);
              });

              data_detail.item_price_per_set = data_detail.item_amount;
              data_detail.options.push(data);
            });

            data_detail.note = detail.note;
            data_detail.order_type = detail.order_type;

            if (detail.percentage === 0) {
              data_detail.item_discount_amount = detail.discount;
            }

            vm.invoice.push(data_detail);
            vm.$store.dispatch("order/fetchOrderItem", vm.invoice);
          }
        } else {
          this.is_new_order = true;
        }
      },

      setCustomer(customer) {
        // if (this.customer.id === customer.id) {
        //   this.customer = {
        //     id: 0,
        //     name: this.$t("none"),
        //   };
        //   return;
        // }
        this.$notify({
          group: "add_item_invoice_notification",
          title: customer.name + " is selected",
          type: "info",
          speed: 300,
          duration: 2000,
        });
        this.customer = customer;
        this.modal_customer = false;
      },
      async applyCoupon() {
        let data = {
          type_id: this.restaurant.id,
          type: "restaurant",
          coupon: this.coupon_code,
          total: this.total.toString(),
        };
        if (this.coupon_price != null)
          await store.dispatch("order/postApplyCouponCode", data);
      },
      async fn_getAllItems(category) {
        this.selected_category.id = 0;
        this.search_item = "";
        let input = {
          type_id: this.restaurant.id,
          type: "restaurant",
          page: "1",
          search: this.search_item,
          limit: "100",
          category: this.selected_category.id,
        };
        await this.getCategories();
        await this.$store.dispatch("order/fetchProduct", input);
        await this.$store.dispatch("popup/updateCategoryPopAction", false);
        this.category_text = "All Items";
      },

      getMoreItems(page) {
        let page_count = Number(this.meta_item.current_page) + Number(page);
        let input = {
          type_id: this.restaurant.id,
          type: "restaurant",
          page: page_count,
          search: this.search_item,
          limit: "100",
          category_id: this.selected_category.id,
        };
        this.$store.dispatch("order/fetchMoreItems", input);
      },

      async getCategories() {
        this.category = [];
        this.meta_category = [];
        let data = {
          type_id: this.restaurant.id,
          type: "restaurant",
          search: this.search_item,
          page: "1",
          limit: "100",
        };
        await store.dispatch("category/fetchCategory", data);
        this.category = this.categories;
        if (this.category) {
          let data = _.filter(this.categories, function (el) {
            // return el.parent_id === 0;
            return el.parent_id === 0 || el.parent_id <= -1;
          });
          this.parent_category = data;
        }
      },

      getChild(child) {
        let data = _.filter(this.category, function (el) {
          return el.parent_id === child.id;
        });
        if (!data.length > 0) {
          this.fn_fetchItemsByCategory(child);
          this.modal_category = false;
          return;
        }
        this.parent_category = data;
        this.meta_category = child;
        this.fn_fetchItemsByCategory(child);
      },
      backButton(child) {
        let data = _.filter(this.category, function (el) {
          return el.parent_id === child.parent_id;
        });
        if (!data.length > 0) return;
        this.parent_category = data;
        let parent_id = 0;
        if (child.parent_id === 0) {
          parent_id = child.id;
        } else {
          parent_id = child.parent_id;
        }
        // find next parent
        let previousParent = _.find(this.category, function (el) {
          return el.id === parent_id;
        });
        if (child.parent_id === 0) {
          this.meta_category = [];
        } else this.meta_category = previousParent;
        this.fn_fetchItemsByCategory(child);
      },

      async fn_fetchItemsByCategory(child) {
        let data_category = {
          type_id: this.restaurant.id,
          type: "restaurant",
          search: this.search_item,
          page: "1",
          limit: "1000",
          category_id: child.id,
        };
        this.selected_category = child;
        await store.dispatch("order/fetchItemsByCategory", data_category);
      },

      openModalMenu(item) {
        this.item_selected = item;
        this.item_form_add = true;
        this.item_quantity = 1;
        this.item_note = "";
        this.selected_options = [];
        this.selected_checkbox = [];
        this.item_discount_percent = this.item_discount_amount = 0;

        // in case item is modify price 
        if(item.is_special == true){
          this.modal_item = true;
          this.modal_item_select_tab = 1;
          return;
        }

        let vm = this;
        if (item.options.length > 0) {
          _.forEach(item.options, function (menu) {
            if (menu.type === "Option") {
              if (menu.optionvalues.length > 0) {
                _.forEach(menu.optionvalues, function (menu_op, index) {
                  if (index === 0) {
                    vm.selected_options.push([
                      menu.id,
                      menu_op.id,
                      menu_op.price,
                      menu.title,
                      menu_op.title,
                    ]);
                  }
                });
              }
            } else {
              vm.selected_options.push(null);
            }
          });
        }

        if (item.options.length > 0) {
          this.modal_item = true;
          this.modal_item_select_tab = 1;
        } else {
          this.addItemToBasket();
        }
      },
      async showCustomerDialog() {
        this.modal_customer = true;
        await this.getCustomer();
      },

      async getCustomer() {
        this.model_customer.type_id = this.restaurant.id;
        await store.dispatch(
          "customer/fetch_all_customer",
          this.model_customer
        );
      },

      showModalTable() {
        this.modal_table = true;
      },

      async addItemToBasket(agreePrint) {
        if (this.item_selected.sale_detail_id && agreePrint != true) {
          let sale_detail = this.order_items.find(
            (x) => x.sale_detail_id === this.item_selected.sale_detail_id
          );
          if (sale_detail.quantity_print > this.item_quantity) {
            this.modal_alert_print_qty = true;
            this.modal_alert_print_delete = false;
            return;
          }
        }

        let item = this.item_selected;

        let vm = this;
        let data = {
          options: [],
          item_key: item.id,
          item_id: item.id,
          item_org: item,
          item_price_per_set: item.price,
          item_amount: item.price,
          item_discount_amount: this.item_discount_amount,
          item_discount_percent: this.item_discount_percent,
          discount: this.item_discount_amount || 0,
          sale_detail_id: this.item_selected.sale_detail_id || null,
          note: this.item_note,
        };

        if (this.item_form_add == false) {
          data.item_old_key = item.item_key;
          console.log(item.item_key);
        }
        data.item_key = item.id;
        data.quantity = this.item_quantity;
        //  update later
        data.key_selected_option = vm.selected_options;
        data.key_selected_check_box = vm.selected_checkbox;

        let selectedOption = [];
        _.forEach(vm.selected_checkbox, function (option) {
          if (option) selectedOption.push(option);
        });
        _.forEach(vm.selected_options, function (option) {
          if (option) selectedOption.push(option);
        });
        let options = [];
        _.forEach(selectedOption, function (el) {
          let exist = _.find(options, function (ld) {
            return ld.option_id === el[0];
          });
          if (!exist) {
            options.push({
              option_id: el[0],
              title: el[3],
            });
          }
        });

        if (options.length > 0) {
          _.forEach(options, function (op) {
            let opls = [];
            let optionvalues = _.filter(selectedOption, function (opl) {
              return opl[0] === op.option_id;
            });
            _.forEach(optionvalues, function (option_value) {
              data.item_key =
                data.item_key + "_" + option_value[0] + "_" + option_value[1];
              opls.push({
                option_value_id: option_value[1],
                price: option_value[2],
                title: option_value[4],
              });
              data.item_amount =
                Number(data.item_amount) + Number(option_value[2]);
              data.item_price_per_set = data.item_amount;
            });
            data.options.push({
              option_id: op.option_id,
              title: op.title,
              optionvalues: _.sortBy(opls, "option_value_id"),
            });
          });
        }
        data.order_type = this.order_type;

        // -------- calc discount on item

        if (this.discount_item_is_amount == true) {
          data.item_discount_percent = 0;
          if (this.item_discount_amount > data.item_org.price * data.quantity) {
            this.item_discount_amount = data.discount =
              data.item_org.price * data.quantity;
          } else {
            data.discount = this.item_discount_amount;
          }
        } else {
          data.item_discount_percent = this.item_discount_amount;
          data.discount =
            data.item_price_per_set *
            data.quantity *
            (Number(this.item_discount_amount) / 100);
        }

        // ----------  end discount on item

        if (this.item_form_add) {
          this.invoice.push(data);
          await this.$store.dispatch("order/fetchOrderQty", this.item_quantity);
          await this.$store.dispatch("order/fetchOrderItem", vm.invoice);
        } else {
          await this.$store.dispatch("order/fetchUpdateOrderItem", data);
        }

        this.selected_checkbox = [];
        this.selected_options = [];
        this.item_discount_amount = this.item_discount_percent = null;
        this.modal_item = false;
        this.$notify({
          group: "add_item_invoice_notification",
          title: this.$t("Added"),
          type: "info",
          speed: 300,
          duration: 300,
        });
      },

      async applyDiscount() {
        if (this.discount_selected === "amount") {
          this.discount = Number(this.discount_value);
        }
        if (this.discount_selected === "percent") {
          this.discount = this.sub_total * (Number(this.discount_value) / 100);
        }
        if (this.discount_selected === "code") {
          let order = this.mapOrder();
          await store.dispatch("order/applyPromotionCode", order);
          let discount = await store.getters["order/promotion"];
          this.discount_value = await store.getters["order/tmp_promo_code"];
          if (discount > 0) {
            this.discount = discount;
            this.modal_discount = false;
          }
        
        }
        this.modal_discount = false;
      },
      async applyDiscountCheck() {
        if (this.discount_selected === "code") {
          let order = this.mapOrder();
          await store.dispatch("order/checkApplyPromotionCode", order);
          this.promotion_obj = await store.getters["order/promotion_obj"];
          this.status_code = await store.getters["order/status_code"];
          return;
        }
      },
      showEditItemsDialog(item) {

        this.item_selected = {};
        this.item_form_add = false;
        this.item_note = item.note;
        this.item_selected = item.item_org;
        this.item_selected.item_key = item.item_key;
        if (item.sale_detail_id) {
          this.item_selected.sale_detail_id = item.sale_detail_id;
        }

        this.item_quantity = item.quantity;
        this.selected_options = [];
        this.selected_checkbox = [];
        this.selected_options = item.key_selected_option;
        this.selected_checkbox = item.key_selected_check_box;
        this.modal_item = true;
        this.modal_item_select_tab = 1;
        if (item.item_discount_percent > 0) {
          this.discount_item_is_amount = false;
          this.item_discount_amount = item.item_discount_percent;
        } else {
          this.discount_item_is_amount = true;
          this.item_discount_amount = item.item_discount_amount;
        }
      },
      async findItem() {
        let data = {
          type_id: this.restaurant.id,
          type: "restaurant",
          search: this.search_item,
          page: "1",
          limit: "1000",
        };
        await store.dispatch("order/getItemsByName", data);
      },

      plusItemQuantity(status) {
        this.item_quantity++;
        if (status) {
          this.edit_item_amount =
            this.edit_item_invoice.price * this.item_quantity;
        }
      },
      minusItemQuantity(status) {
        if (this.item_quantity <= 0) {
          this.item_quantity = 1;
          return;
        }
        if (this.item_quantity === 1) {
          return;
        }
        this.item_quantity--;
        if (status) {
          this.edit_item_amount =
            this.edit_item_invoice.price * this.item_quantity;
        }
      },
      delete_item(agreePrint) {
        if (this.item_selected.sale_detail_id && agreePrint != true) {
          // -------------------------------------
          let sale_detail = this.order_items.find(
            (x) => x.sale_detail_id === this.item_selected.sale_detail_id
          );

          if (sale_detail.quantity_print < sale_detail.quantity) {
            this.modal_alert_print_qty = true;
            this.modal_alert_print_delete = true;
            return;
          }
          // this.removed_sale_details.push(this.item_selected.sale_detail_id);
        }

        this.removed_sale_details.push(this.item_selected.sale_detail_id);
        // console.log(this.removed_sale_details);
        this.$store.dispatch(
          "order/deleteOrderItems",
          this.item_selected.item_key
        );
        this.modal_item = false;
      },
      clearOrder() {
        this.customer = { name: "default", id: 0 };
        this.table_selected = { name: "default", id: 0 };
        this.$store.dispatch("order/clear_order");
        this.discount_value = null;
        this.discount = 0;
        this.discount_selected = "amount";
      },
      clearPromoteCode() {
        this.discount_value = null;
        this.promotion = 0;
        this.discount = 0;
        this.promotion_obj = {};
        this.$store.dispatch("order/clearTmpPromoCode");
      },
      mapOrder() {
        let order = {
          promotion_obj: this.promotion_obj,
          promotion: this.promotion,
          total: this.total,
          sub_total: this.sub_total,
          discount: this.discount,
          percentage: null,
          coupon: this.discount_value,
          note: this.order_note,
          type_id: this.restaurant.id,
          type: "restaurant",
          is_paid: this.is_paid,
          currency_id: this.selected_currency.id,
          exchangerate: this.selected_currency.rate,
          location_id: this.table_selected.id,
          customer_id: this.customer.id,
          order_type: this.order_type,
          is_send_email: this.send_email_to_customer,
          removed_sale_details: this.removed_sale_details,
          cash_received: this.totalCashEnter,
          payment_type_id: this.payment_type.id,
          data_cash_receive: {
            data_cash_enter: this.allExchange,
            data_cash_change: this.cash_change,
          },
        };

        if (this.discount_selected === "percent") {
          order.percentage = this.discount_value;
        }

        if (this.discount_selected === "code") {
          order.promotion_code = this.discount_value;
        }

        if (this.is_new_order === false) {
          order.sale_id = this.order_modify.id;
        }
        return order;
      },

      async openModalCredit() {
        if (!this.customer.id) {
          Swal.fire({
            title: this.$i18n.t("Customer is required!"),
            text: this.$i18n.t("Please select a customer!"),
          });
          return null;
        }

        Swal.fire({
          showCancelButton: true,
          confirmButtonText: `Make Credit`,
          title: this.$i18n.t("Cash receive is not equal"),
          text: this.$i18n.t("Do you want to process credit?"),
        }).then((result) => {
          if (result.isConfirmed) {
            this.payment_type = this.credit;
            this.submitOrder();
          }
        });
      },

      async makeCredit() {
        if (!this.customer.id) {
          Swal.fire({
            title: this.$i18n.t("Customer is required!"),
            text: this.$i18n.t("Please select a customer!"),
          });
          return;
        }
        await this.submitOrder();
      },

      async submitOrder(print) {
          await store.dispatch("order/clearTmpPromoCode");
        if (this.credit?.id == this.payment_type.id) {
          this.allExchange.forEach((v, index) => {
            this.allExchange[index].cash_enter = 0;
          });
        }

        this.save_order_loading = true;
        let order = this.mapOrder();
        if (order.is_paid === "YES") {
          if (
            this.isAllowCredit == false &&
            this.totalCashEnter < this.finalPay
          ) {
            this.save_order_loading = false;
            return null;
          }
        }
      
        await store.dispatch("order/submitOrder", order);
        this.modal_confirm = false;
        this.discount_value = null;

        if (this.order_status) {
          if (!this.order_modify.id) {
            this.clearOrder();
          }
          if (order.is_paid === "YES") {
            this.clearOrder();
            await this.$store.dispatch("order/modifyOrder", {});
            this.is_new_order = true;
          } else {
            await this.$store.dispatch("order/modifyOrder", {});
            this.clearOrder();
            this.is_new_order = true;
          }
        }

        if (this.print_preview) {
          this.$store.commit("order/ORDER", this.order_preview);
          this.save_order_loading = false;
          return this.$router.push({ name: "printing" });
        }
        this.save_order_loading = false;
        await store.dispatch("order/clearTmpPromoCode");
          this.discount_value = null;
          this.discount = 0;
          this.promotion = 0;
          this.promotion_obj = {};
      },
      async openConfirm(pay) {
        this.index_all_exchange = 0;
        if (this.order_type === "walk_in" && this.table_selected.id <= 0) {
          Swal.fire({
            confirmButtonText: this.$i18n.t("yes"),
            text: this.$i18n.t("Please Select") + " " + this.$i18n.t("Table"),
          });
          return;
        }
        if (this.order_type === "hotel_guest" && this.table_selected.id <= 0) {
          Swal.fire({
            confirmButtonText: this.$i18n.t("yes"),
            text: this.$i18n.t("Please Select") + " " + this.$i18n.t("Room"),
          });
          return;
        }

        this.is_paid = pay;
        this.cash_receive = 0;
        this.modal_confirm = true;
        this.payment_type = this.restaurant.payment_type[0];
      },

      async createCustomer() {
        if (this.customer.id > 0) {
          this.customer = {};
          return;
        }
        if (!this.customer.name) return;

        let data = this.customer;
        data.restaurant_id = this.restaurant.id;
        await store.dispatch("customer/create_customer", data);
        let customer = await store.getters["customer/customer"];

        if (customer.id) {
          this.customer = customer;
        }
      },
      flat_modal_table(value) {
        this.modal_table = value;
      },
      async sendOrder() {
        let order = this.mapOrder();
        await store.dispatch("order/submitOrder", order);
        this.$store.dispatch("order/modifyOrder", this.sale);
        this.setModifyToOrder();
        await store.dispatch("order/updatePrintQty");
        await store.dispatch("printer/sendOrderToPrinter", this.order_modify);

      this.discount_value = null;
        this.promotion = 0;
        this.discount = 0;
        this.promotion_obj = {};
        await store.dispatch("order/clearTmpPromoCode");
      },
      openSaleFromTable(data) {
        if (data == true) {
          this.setModifyToOrder();
        }
      },

      exact() {
        let index = 0;
        for (let item of this.allExchange) {
          this.allExchange[index].cash_enter = "";
          if (this.selected_currency.code == item?.code) {
            this.allExchange[index].cash_enter = _.round(
              this.finalPay * this.selected_currency.rate,
              4
            );
          }
          index++;
        }
      },
    },
  };
</script>
